export const HEAP_APP_ID_DEV = '2275313609';
export const HEAP_APP_ID_QA = '1220800181';
export const HEAP_APP_ID_UAT = '3120842437';
export const HEAP_APP_ID_PROD = '2882405371';
